import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'public'
if(localStorage.getItem('userRole')) initialRole = localStorage.getItem('userRole')

export default new AclCreate({
  initial: initialRole,
  // notfound: '/pages/not-authorized', 
  /* notfound: '/error', */
  /*   notfound: {
    path: '/error',
    forwardQueryParams: true,
  }, */
  router,
  acceptLocalRules: true,
  globalRules: {
    admin: new AclRule('admin').generate(),
    public: new AclRule('public').or('admin').generate(),
    manager: new AclRule('manager').or('public').or('admin').generate(),
  }
})
